module.exports = __webpack_public_path__ + "img/chalk_12.a1a1f17c.png";